import Navbar from './Navbar';
import Seo from './Seo';
import SkillItem from './SkillItem';
import skills from './skills.js';
const About = () => {
    return (
        <div>
            <Seo
                title='About — Elmira Saifullina'
                description='Full-Stack JavaScript Engineer with 4+ years of experience across TypeScript, React, Next.js, Node.js, AWS and more.'
                path='/about'
            />
            <Navbar />
            <h1 className='text-4xl pt-10 pb-3 page-header'>About me</h1>
            <p className='w-11/12 lg:w-8/12 mx-auto text-2xl'>
                {`I am a Full-Stack JavaScript Engineer with over 4 years of experience building and scaling web applications
                across the TypeScript, React, Next.js, and Node.js ecosystems. I have worked on high-throughput AWS data
                pipelines and real-time sensor telemetry, designed interactive data-visualization dashboards, and led
                large-scale frontend migrations that cut technical debt and improved performance.`}
            </p>
            <p className='w-11/12 lg:w-8/12 mx-auto text-2xl mt-6'>
                {`My path into tech began with a degree in Linguistics and a genuine love of computers - I taught myself
                JavaScript and never looked back. That background makes me obsessive about writing clear, maintainable code
                and communicating well across product and engineering teams. I care about shipping through small,
                well-tested iterations and about the details that make software a pleasure to use.`}
            </p>
            <p className='text-3xl colored-text my-12'>Skills</p>
            <div className='grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10 w-11/12 lg:w-8/12 mx-auto mb-5'>
                {skills.map((skill, index) => (
                    <SkillItem key={index} skill={skill} index={index} />
                ))}
            </div>
        </div>
    );
};
export default About;
